import CampaignProductPanel from './campaignProductPanel.container';

export default CampaignProductPanel;